/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentage change compares a new value to a specific original value. Percentage difference compares two values relative to their average, with no fixed starting point.`)
};

const es_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El cambio porcentual compara un valor nuevo con un valor original específico. La diferencia porcentual compara dos valores en relación con su promedio, sin un punto de partida fijo.`)
};

const de_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die prozentuale Veränderung vergleicht einen neuen Wert mit einem bestimmten Ausgangswert. Der prozentuale Unterschied vergleicht zwei Werte relativ zu ihrem Durchschnitt, ohne festen Ausgangspunkt.`)
};

const nl_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percentageverandering vergelijkt een nieuwe waarde met een specifieke oorspronkelijke waarde. Percentageverschil vergelijkt twee waarden ten opzichte van hun gemiddelde, zonder vast startpunt.`)
};

const fr_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variation en pourcentage compare une nouvelle valeur à une valeur d'origine précise. La différence en pourcentage compare deux valeurs par rapport à leur moyenne, sans point de départ fixe.`)
};

const it_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La variazione percentuale confronta un nuovo valore con un valore originale specifico. La differenza percentuale confronta due valori rispetto alla loro media, senza un punto di partenza fisso.`)
};

const pt_br2_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual compara um novo valor a um valor original específico. A diferença percentual compara dois valores em relação à sua média, sem um ponto de partida fixo.`)
};

const pt_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A variação percentual compara um novo valor com um valor original específico. A diferença percentual compara dois valores em relação à sua média, sem um ponto de partida fixo.`)
};

const ja_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パーセント変化は新しい値を特定の元の値と比較します。パーセントの差は、固定の開始点を持たず、2つの値をその平均に対して比較します。`)
};

const zh_pct_difference_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`百分比变化将新值与特定的原始值进行比较。百分比差异则将两个数值相对于其平均值进行比较，没有固定的起点。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_difference_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_difference_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_difference_faq1_a", locale)
	if (locale === "en") return en_pct_difference_faq1_a(inputs)
	if (locale === "es") return es_pct_difference_faq1_a(inputs)
	if (locale === "de") return de_pct_difference_faq1_a(inputs)
	if (locale === "nl") return nl_pct_difference_faq1_a(inputs)
	if (locale === "fr") return fr_pct_difference_faq1_a(inputs)
	if (locale === "it") return it_pct_difference_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_pct_difference_faq1_a(inputs)
	if (locale === "pt") return pt_pct_difference_faq1_a(inputs)
	if (locale === "ja") return ja_pct_difference_faq1_a(inputs)
	return zh_pct_difference_faq1_a(inputs)
};